import axios from 'axios';
import authService from './auth';

// 从环境变量获取API基础URL，如果不存在则使用默认值
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 在控制台打印实际使用的API基础URL，用于调试
console.log('使用的API基础URL:', API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000
});

// 创建一个用于文件上传的客户端实例，不设置Content-Type，让其自动设置为multipart/form-data
const uploadClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  timeout: 60000 // 上传文件可能需要更长的超时时间
});

// 为两个客户端都设置认证拦截器
authService.setupInterceptors(apiClient);
authService.setupInterceptors(uploadClient);

// 移除了响应拦截器，每个组件自行处理响应数据

export const stickerApi = {
  getStickers(page = 1, size = 12, sortBy = 'likes', order = 'desc', title = '') {
    return apiClient.get(`/stickers/list`, {
      params: {
        page,
        size,
        sortBy,
        order,
        title // 添加title参数用于搜索
      }
    });
  },
  
  // 上传表情包
  uploadSticker(file, title = '') {
    // 创建FormData对象
    const formData = new FormData();
    formData.append('file', file);
    
    // 如果有标题则添加
    if (title) {
      formData.append('title', title);
    }
    
    return uploadClient.post('/stickers/upload', formData);
  },
  
  // 点赞或点踩表情包
  voteSticker(id, type) {
    return apiClient.post('/stickers/vote', {
      id,
      type  // 0表示点踩，1表示点赞
    });
  },

  // 获取随机表情包
  getRandomSticker() {
    return apiClient.get('/stickers/rand');
  },
  
  // 删除表情包
  deleteSticker(id) {
    return apiClient.post('/stickers/delete', null, {
      params: { id }
    });
  }
};

export default {
  stickerApi
};